import React from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import Captcha from './../../../components/captcha/captcha.component'
import { isMobile } from '../../../helpers/window.helper'
import { history } from '../../../helpers/history'
import ModalForgotPassword from './modal-forgot-password'
import { GRAY } from '../../../styles/colors.style'
import { routes } from '../../../constants/routes.constants'
import { breakpoints } from '../../../constants'
import {
	facebookApp,
	googleApp
} from '../../../constants/social-login.constants'
import { connect } from 'react-redux'
import { Form, Formik } from 'formik'
import { toastActions } from '../../../actions'
import { AuthenticationService } from './../../../services/authentication.service'
import { Creators as AuthenticationCreators } from '../../../ducks/authentication/authentication'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import {
	PasswordInput,
	TextInput
} from '../../../components/form-components/inputs.component'
import * as Yup from 'yup'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'

const schema = Yup.object().shape({
	login: Yup.string().required('Informe um login'),
	password: Yup.string().required('Informe a senha')
})
import faceLogo from '../../../../assets/icons/facebook-logo.svg'

const StyledFormContainer = styled.div`
	.form {
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		width: 350px;
		margin-bottom: 40px;
	}

	@media (max-width: 380px) {
		.form {
			width: 90%;
		}
	}

	.button {
		align-self: center;
		width: fit-content;

		@media screen and (max-width: 700px) {
			width: 100%;
		}
	}

	.recuperar-senha {
		margin-top: 2.4rem;
		font-size: 15px;
		font-weight: 400;
	}

	.cadastre-se {
		background: linear-gradient(to bottom, #1e5799 0%, #517abc 100%);
		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			margin-top: 12px;
		}
	}

	.social-login-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		button {
			width: 300px;
			margin-top: 10px;
		}
		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			display: flex;
			width: 100%;
			button {
				height: 40px;
			}
		}
	}

	.custom-google-button {
		height: 56px;
		padding-left: 1.8rem !important;
		padding-right: 1.8rem !important;
	}

	.custom-facebook-button {
		font-size: 14px;
		height: 56px;
		border-radius: 5px;
		padding-left: 1.8rem;
		padding-right: 1.8rem;

		background-color: #1977f3;
		display: inline-flex;
		align-items: center;
		color: white;
		border: 1px solid transparent;
		font-weight: 500;
		font-family: Roboto, sans-serif;
		cursor: pointer;
	}

	.custom-facebook-button img {
		margin: 0 16px 0px 3px;
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

function captchaOnChange(value) {
	if (this.state.isSubmitting && value) handleSubmit.call(this)
}

function showModal() {
	this.setState({ modalIsOpen: true, modalLogin: '' })
}

async function handleSubmitModal({ modalLogin }) {
	const { showLoading, hideLoading } = this.props
	showLoading()
	AuthenticationService.requestPasswordReset(modalLogin)
		.then(({ success, errors = [] }) => {
			hideLoading()
			this.setState({ modalIsOpen: false })
			if (success) {
				this.props.success(
					'Um e-mail para redefinição de senha será enviado'
				)
			} else if (Array.isArray(errors) && errors.length) {
				this.props.warning(errors[0])
			} else {
				this.props.danger(
					'Não foi possível enviar o e-mail de redefinição de senha, por favor tente novamente mais tarde'
				)
			}
		})
		.catch(() => {
			hideLoading()
			this.props.danger(
				'Não foi possível enviar o e-mail de redefinição de senha, por favor tente novamente mais tarde'
			)
		})
}

function validateCaptcha(values, actions) {
	this.setState({ isSubmitting: true, values, actions })
	this.captcha.execute()
}

function handleSubmit() {
	const { values, actions } = this.state
	this.captcha.reset()
	this.props.handleSubmit(values, actions)
}

class LoginForm extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			values: null,
			actions: null,
			modalLogin: '',
			modalIsOpen: false,
			isSubmitting: false
		}
		this.captcha = {}
	}

	handleSocialLoginResponse = res => {
		const { successfulAuthentication, setProviderSignupData } = this.props
		if (res.data.shouldRedirectToSignUp) {
			setProviderSignupData(res.data)
			history.push(routes.LOGIN_SOCIAL_CADASTRO)
		} else if (!!res.data.accessToken) {
			successfulAuthentication(res)
		}
	}

	onFacebookResponse = providerResponse => {
		const { hideLoading, showLoading } = this.props
		const message =
			'Não foi possível autenticar com o Facebook, tente novamente mais tarde.'
		if (providerResponse.status === 'unknown') return

		if (providerResponse.status && providerResponse.status !== 'unknown') {
			this.props.danger(message)
			return
		}

		showLoading()
		AuthenticationService.socialLogin('facebook', {
			AccessToken: providerResponse.accessToken
		})
			.then(result => {
				this.handleSocialLoginResponse(result)
				hideLoading()
			})
			.catch(() => {
				this.props.danger(message)
				hideLoading()
			})
	}

	onGoogleResponse = providerResponse => {
		const { hideLoading, showLoading } = this.props
		const message =
			'Não foi possível autenticar com o Google, tente novamente mais tarde.'
		showLoading()
		AuthenticationService.socialLogin('google', {
			TokenId: providerResponse.tokenId
		})
			.then(result => {
				this.handleSocialLoginResponse(result)
				hideLoading()
			})
			.catch(() => {
				hideLoading()
				this.props.danger(message)
			})
	}

	onGoogleError = errors => {
		console.warn(errors)
	}

	render() {
		const { user } = this.props
		return (
			<StyledFormContainer>
				<Formik
					ref="form"
					initialValues={user}
					onSubmit={validateCaptcha.bind(this)}
					validationSchema={schema}
					render={props => (
						<Form className="form" noValidate>
							<StyledInputContainer>
								<TextInput
									id="login"
									label="Informe o seu e-mail, CPF ou Número Muviflex"
									maxLength={128}
									autoFocus={true}
									{...props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<PasswordInput
									id="password"
									label="Informe sua senha Muviflex (Letras e Números)"
									maxLength={256}
									{...props}
								/>
							</StyledInputContainer>
							<Captcha
								onChange={captchaOnChange.bind(this)}
								ref={el => {
									this.captcha = el
								}}
							/>
							<Button
								link
								color={GRAY}
								className="recuperar-senha"
								type="button"
								onClick={showModal.bind(this)}>
								Esqueci a senha
							</Button>
							<div className="social-login-container">
								<Button
									primary
									className={`button button-modal`}
									type="submit">
									ENTRAR COM E-MAIL OU CPF
								</Button>
								<GoogleLogin
									clientId={googleApp.clientId}
									buttonText="Entrar com o Google"
									onSuccess={this.onGoogleResponse}
									className="custom-google-button"
									onFailure={this.onGoogleError}
									cookiePolicy={'single_host_origin'}
								/>
								{/* <FacebookLogin
									appId={facebookApp.appId}
									fields="id,name,email"
									icon={<img src={faceLogo} alt="" />}
									cssClass="custom-facebook-button"
									callback={this.onFacebookResponse}
									textButton="Entrar com o Facebook" /> */}
							</div>
						</Form>
					)}
				/>
				<ModalForgotPassword
					isOpen={this.state.modalIsOpen}
					onClose={() => this.setState({ modalIsOpen: false })}
					onSubmit={handleSubmitModal.bind(this)}
				/>
			</StyledFormContainer>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return {
		hideLoading: () => dispatch(SiteCreators.hideLoading()),
		showLoading: () => dispatch(SiteCreators.showLoading()),
		danger: message => dispatch(toastActions.danger({ message })),
		success: message => dispatch(toastActions.success({ message })),
		warning: message => dispatch(toastActions.warning({ message })),
		setProviderSignupData: data =>
			dispatch(AuthenticationCreators.setProviderSignupData(data))
	}
}

const connectedComponent = connect(null, mapDispatchToProps)(LoginForm)
export { connectedComponent as LoginForm }
